import React, { useState } from "react";
import Login from "./Login";
import Register from "./Register";

function App() {
    const [showRegister, setShowRegister] = useState(false);

    return (
        <div>
            {!showRegister ? (
                <Login onSwitchToRegister={() => setShowRegister(true)} />
            ) : (
                <Register onSwitchToLogin={() => setShowRegister(false)} />
            )}
        </div>
    );
}

export default App;